import { memo, useEffect, useState } from "react";

const ImageLogo = ({ src, alt, style, ...props }) => {
  const [loaded, setLoaded] = useState(false);

  // Reset loaded state when src changes
  useEffect(() => {
    setLoaded(false);
  }, [src]);

  return (
    <img
      src={src}
      alt={alt}
      style={{
        opacity: loaded ? 1 : 0,
        transition: "opacity 0.4s",
        ...style,
      }}
      onLoad={() => setLoaded(true)}
      {...props}
    />
  );
};

export default memo(ImageLogo);
